<template>
  <div id="zhibochat" class="relativeItem">
    <!--送礼物-->
    <div id="giftHeadDiv" class="gift giftSender" v-show="showLiwuHead">
      <div id="liwuHeadDiv" class="radius3">
        <img class="head radius50" :src="songliwu.headImg">
        <span class="name apostrophe">{{ songliwu.send }}</span>
        <img class="gImg" :src="liwuImg">
        <span id="liwuNum" class="num">x {{ songliwu.num }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import cookie from "../../utils/cookie";
import "../../utils/topAction.css";
import live from "../../utils/live";
import wSocket from "../../utils/ws";

export default {
  name: "zhibochat",
  components: {},
  data() {
    return {
      djs: 0, //关闭礼物头像的倒计时器
      showLiwuHead: false,
      closeLiwuHdad: true,
      liwuImg: "",
      liwuID: "",
      gifts: [],
      songliwu: [], //送礼物的时候头像显示
      wsUlr: "",
      perInfo: [], //用户个人信息
      show: false, //显示贵宾
      see: 0 //0贵宾，1贡献，2观众
    };
  },
  methods: {
    /**获取ws通道地址 */
    getWsAdd() {
      let _this = this;
      let data = {};
      this.$jsonp(this.$apis("wsAdd"), data, res => {
        _this.wsUlr = res.data.data.result;
        _this.getInfo();
      });
    },

    /**创建ws对象，并对接受的信息进行处理 */
    creatWs() {
      let _this = this;
      //获取用户信息之后，再调用这个接口
      let wsUlr = "";
      if (window.location.host == "test.h5.fjkankan.com") {
        wsUlr = "ws://120.78.6.232:19355"; //测试
      } else if (window.location.host == "localhost:8080") {
        wsUlr = "ws://120.78.6.232:19355"; //测试
      } else {
        wsUlr = this.wsUlr;
      }
      
      let ws = wSocket.able(wsUlr);
      ws.onopen = function() {
        let data = {
          action2: "into",
          roomnumber: _this.$route.query.roomnumber,
          botinfo: "",
          chatuserinfo: ""
        };

        if (!_this.$tool.isStr(cookie.getC("token"))) {
          //未登录情况下以游客身份登录
          let what = Math.random()
            .toString(18)
            .substr(2);
          data.nickname = "Guest_" + what;
          data.usernumber = what;
          data.userid = what;
          data.token = "";
        } else {
          data.nickname = _this.perInfo.nickname;
          data.token = cookie.getC("token");
          data.userid = _this.perInfo.userid;
          data.usernumber = _this.perInfo.usernumber;
        }

        data = JSON.stringify(data);
        ws.send(data);
        //每10秒向服务器发送一次数据保持服务器和客户端的连接不断
        //也就是所谓的心跳
        setInterval(() => {
          ws.send("");
        }, 10000);
      };

      ws.onmessage = function(evt) {
        var res = JSON.parse(evt.data);
        // console.log(res);
        if (res.action2 == "welcome") {
          //进场
          live.into(res, "zhibochat");
        } else if (res.action2 == "getMessage") {
          //公共聊天
          live.say(res, "zhibochat");
        } else if (res.action2 == "getPrivateMessage") {
          //私人聊天
          live.sayPerson(res, "zhibochat");
        } else if (res.action2 == "sendGiftResult") {
          if (res.r.indexOf("SYS") != -1) {
            //接受公告
            live.getGonggao(res, "zhibochat");
          } else if (res.r.indexOf("SFM0") != -1) {
            //飞屏信息，不用管
          } else {
            //接收礼物
            _this.closeLiwuHdad = false;
            let userid = res.r.split(",|")[5].split("-")[0];
            let headImg =
              live.origin +
              "/apis/avatar.php?uid=" +
              userid;
            let send = res.chatuserinfo.split("-")[1]; //送礼物的人
            let id = res.r.split(",|")[8];
            if (_this.liwuID != id) {
              _this.liwuID = id;
              //循环遍历礼物ID获取图片
              _this.gifts.forEach(e => {
                if (e.giftid == _this.liwuID) {
                  _this.liwuImg = e.giftimage;
                }
              });
            }

            let img = null;
            let num = res.attach;
            let data = {
              userid: userid,
              headImg: headImg,
              send: send,
              img: img,
              num: num
            };
            _this.djs = 2;
            if (_this.showLiwuHead) {
              setTimeout(() => {
                _this.songliwu.num = res.attach;
              }, 300);
            } else {
              _this.songliwu = data;
            }
            _this.showLiwuHead = true;
            _this.setLiwuHead(res.attach);

            live.getGift(res, "zhibochat");
          }
        }
      };
    },
    //获取个人信息
    getInfo() {
      let _this = this;
      let data = {};
      this.$jsonp(this.$apis("me"), data, res => {
        _this.perInfo = res.data.data.result;
        _this.creatWs();
      });
    },
    /**请求礼物图片 */
    getGiftPic() {
      let _this = this;
      let data = {};
      this.$jsonp(this.$apis("zhiboliwu"), data, res => {
        _this.gifts = res.data.data.result;
      });
    },
    /**设置礼物head的宽度 */
    setLiwuHead(num) {
      let span = this.$tool.getByID("liwuNum");
      if (num * 1 >= 10 && num * 1 < 100) {
        span.style.right = "-33%";
      } else if (num * 1 >= 100 && num * 1 < 1000) {
        span.style.right = "-44%";
      } else if (num * 1 >= 1000 && num * 1 < 10000) {
        span.style.right = "-52%";
      } else if (num * 1 >= 10000 && num * 1 < 100000) {
        span.style.right = "-61%";
      }
    }
  },
  mounted: function() {
    //获取ws通道地址
    this.getWsAdd();
    this.getGiftPic();
    //进入页面就开始进行倒计时
    //当djs为0时关闭礼物头像
    let _this = this;
    let closeImgHead = setInterval(() => {
      if (_this.djs > 0) {
        _this.djs--;
      } else {
        _this.showLiwuHead = false;
      }
    }, 1000);
  }
};
</script>

<style>
#zhibochat {
  overflow-y: scroll;
}
#zhibochat > * {
  margin: 0.3rem;
}

/*礼物*/
.gift {
  display: inline-block;
  width: 100%;
  position: fixed;
  left: 0;
  top: 8rem;
}
.gift > div {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.2);
  font-size: 12px;
  color: #fff;
  display: inline-block;
}
.gift * {
  vertical-align: middle;
}
.gift .name {
  display: inline-block;
  margin: 0 4px;
  max-width: 10rem;
}
.gift .head {
  width: 2rem;
  height: 2rem;
}
.gift .gImg {
  width: 1.9rem;
  margin-right: 3px;
}
.gift .num {
  position: absolute;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  -webkit-text-stroke: 1px #999999;
  top: 50%;
  right: -25%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}

p *{
  vertical-align: middle;
}
#zhibochat p {
  font-size: 13px;
  max-width: 100%;
  text-align: justify;
  padding: 0.2rem 0.5rem;
  color: #fff;
  display: inline-block;
  line-height: 1.2rem;
}
#zhibochat p img {
  vertical-align: middle;
}
.chats img {
  transform: translateY(-0.06rem);
  -webkit-transform: translateY(-0.06rem);
  margin-right: 4px;
}
/*聊天信息*/
.putong {
  background: rgba(0, 0, 0, 0.2);
}
.fen {
  border: 1px solid #ff9abe;
  background: rgba(255, 154, 190, 0.2);
}
.lan {
  border: 1px solid #74b9ff;
  background: rgba(116, 185, 255, 0.2);
}
.huang {
  border: 1px solid #fdcb6e;
  background: rgba(253, 303, 110, 0.2);
}

.rightTop {
  width: 1rem;
  height: 1rem;
  top: -0.5rem;
  right: -0.5rem;
}

.level {
  width: 33px;
  height: 14px;
}

.guizu {
  width: 20px;
  height: 20px;
}

.fan {
  width: 14px;
  height: 14px;
}

/*进场*/
.jinchang {
  background: rgba(0, 0, 0, 0.2);
  padding: 0.2rem 0.5rem;
  padding-right: 0.7rem;
}
.huang{
  background: rgba(0, 0, 94, 0.5);
  border: 1px solid #d4e55e;
}
.jinchang * {
  vertical-align: middle;
}

/*送礼物信息的名称*/
.giftName {
  color: #ffd280;
}
.giftItem {
  color: #f97fab;
}
</style>
